export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14641.7a47ffde.jpg";